import { render } from "./SaleEditorPanel.vue?vue&type=template&id=24d433f0&scoped=true"
import script from "./SaleEditorPanel.vue?vue&type=script&lang=js"
export * from "./SaleEditorPanel.vue?vue&type=script&lang=js"

import "./SaleEditorPanel.vue?vue&type=style&index=0&id=24d433f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d433f0"]])

export default __exports__